// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dv360-container {
    --primary-50: #e9f2ff;
    --primary-300: #7fb7ff;
    --primary-500: #0077d6;
    --muted: #6b7280;

    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
    line-height: 1.65;
    margin: 24px;
    padding: 32px;
    background: linear-gradient(180deg, var(--primary-50), #f6fbff);
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(2,48,84,0.06);
    color: #042a48;
}
.dv360-title-headline{
    font-size: 26px;
    font-weight: 800;
    color: var(--primary-700, #035aa6);
    margin-bottom: 8px;
}
.dv360-sub-title-headline{
    font-size: 18px;
    font-weight: 700;
    margin-left: 20px;
    color: #07355f;
}
.dv360-text{
    margin-left: 28px;
    color: var(--muted);
}
.dv360-img{
    max-width: 100%;
    height: auto;
    padding: 18px 0;
    border-radius: 8px;
    box-shadow: 0 8px 20px rgba(2,48,84,0.04);
}
.dv360-sub-text{
    margin-left: 36px;
    color: var(--muted);
}

@media (max-width: 900px) {
    .dv360-container { padding: 18px; margin: 12px; }
    .dv360-sub-title-headline, .dv360-text, .dv360-sub-text { margin-left: 12px; }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/pmp/dv360.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;;IAEhB,2FAA2F;IAC3F,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,+DAA+D;IAC/D,mBAAmB;IACnB,0CAA0C;IAC1C,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yCAAyC;AAC7C;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB,aAAa,EAAE,YAAY,EAAE;IAChD,0DAA0D,iBAAiB,EAAE;AACjF","sourcesContent":[".dv360-container {\n    --primary-50: #e9f2ff;\n    --primary-300: #7fb7ff;\n    --primary-500: #0077d6;\n    --muted: #6b7280;\n\n    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;\n    line-height: 1.65;\n    margin: 24px;\n    padding: 32px;\n    background: linear-gradient(180deg, var(--primary-50), #f6fbff);\n    border-radius: 12px;\n    box-shadow: 0 10px 30px rgba(2,48,84,0.06);\n    color: #042a48;\n}\n.dv360-title-headline{\n    font-size: 26px;\n    font-weight: 800;\n    color: var(--primary-700, #035aa6);\n    margin-bottom: 8px;\n}\n.dv360-sub-title-headline{\n    font-size: 18px;\n    font-weight: 700;\n    margin-left: 20px;\n    color: #07355f;\n}\n.dv360-text{\n    margin-left: 28px;\n    color: var(--muted);\n}\n.dv360-img{\n    max-width: 100%;\n    height: auto;\n    padding: 18px 0;\n    border-radius: 8px;\n    box-shadow: 0 8px 20px rgba(2,48,84,0.04);\n}\n.dv360-sub-text{\n    margin-left: 36px;\n    color: var(--muted);\n}\n\n@media (max-width: 900px) {\n    .dv360-container { padding: 18px; margin: 12px; }\n    .dv360-sub-title-headline, .dv360-text, .dv360-sub-text { margin-left: 12px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
